// System Settings Service (client)
// Note: uses fetch for the public status endpoint to avoid auth headers

// Fetches and updates settings via admin API
import adminApiService from "./adminApiService";

export async function fetchSystemSettings() {
  const res = await adminApiService.get("/system/settings");
  return res.settings || [];
}

export async function updateSystemSettings(settings) {
  return adminApiService.patch("/system/settings", { settings });
}

import apiClient from "../utils/apiClient";

export async function fetchMaintenanceStatus() {
  try {
    const { data } = await apiClient.get("/api/system/status");
    return data;
  } catch (e) {
    return { maintenanceMode: false };
  }
}
